const error404 = {
    title: 'Oops...',
    header: 'This page is not found 😳',
    message: "",
    link: 'Go back to Home page',
}

export default error404
